export const oAuth2ActionData = [
  {
    name: 'loginWithOAuth2',
    label: 'Login with OAuth 2',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'signUpWithOAuth2',
    label: 'Sign Up with OAuth 2',
    args: [
      {
        name: 'userRole',
        label: 'Select User Role',
        type: 'dropdown',
        optionsType: 'userRoleApi',
        options: [],
        value: '',
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
